<template>
  <div>
    <div class="form-group">
      <label for="projectNameInput"> Project Name: </label>

      <input
        type="text"
        class="form-control required"
        data-toggle="tooltip"
        data-placement="bottom"
        data-trigger="manual"
        title="Please Name Your Project"
        id="projectNameInput"
        placeholder="My Project"
        v-model="name"
        maxlength="30"
      />
    </div>

    <div class="form-group">
      <label for="projectDescriptionInput"> Project Description: </label>

      <textarea
        class="form-control"
        id="projectDescriptionInput"
        placeholder="Project Description (optional)"
        v-model="description"
        cols="30"
        rows="3"
      />
    </div>

    <div class="form-group">
      <label for="projectDescriptionInput"> Project Tab Color: </label>

      <swatches-picker v-model="color" :palette="projectTabColorPalette" />
    </div>

    <a
      class="btn btn-raised btn-danger btn-xl font-weight-semibold"
      href="#"
      v-on:click.prevent="save"
    >
      Create
    </a>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import { Swatches } from "vue-color";

export default Vue.component("create-project", {
  name: "CreateProject",

  data() {
    return {
      name: "",
      description: null,
      color: false,
      convertingQuicklist: false,
      projectTabColorPalette: window.projectTabColorPalette
        ? window.projectTabColorPalette
        : [],
    };
  },

  mounted() {
    // Change the create project contents depending on whats passed to it.
    playerService.$on("create-project", (convertingQuicklist) => {
      this.convertingQuicklist = convertingQuicklist;

      this.reset();

      // Open the modal.
      window.webpackOpenBsModalWorkaround("#createProjectModal");

      $("#createProjectModal").on("shown.bs.modal", () => {
        $("#projectNameInput").focus();
      });
    });
  },

  methods: {
    save() {
      if (this.name === "") {
        $("#projectNameInput").addClass("is-invalid");
        $("#projectNameInput").tooltip("show");
        return;
      }

      if (this.color) {
        this.color = this.color.hex;
      }

      if (this.convertingQuicklist) {
        playerService.saveQuicklistAsProject(
          this.name,
          this.description,
          this.color,
        );
      } else {
        playerService.storeProject(this.name, this.description, this.color);
      }
    },

    reset() {
      this.name = "";

      $("#projectNameInput").removeClass("is-invalid");

      this.description = null;
      this.color = false;
    },
  },

  watch: {
    name(value) {
      if (value) {
        if ($("#projectNameInput").hasClass("is-invalid")) {
          $("#projectNameInput").removeClass("is-invalid");
          $("#projectNameInput").tooltip("hide");
        }
      }
    },
  },

  components: {
    "swatches-picker": Swatches,
  },
});
</script>
